export const NON_WTR_COUNTRIES: string[] = []

export const NON_DESKTOP_TT_COUNTRIES: string[] = [
    'JPN'
]
